import { useTheme } from 'styled-components';

import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const SwapIconGe: React.FC<SvgIconDefaultProps> = ({
  color,
  className,
  testId,
}) => {
  const { colors } = useTheme();
  const iconColor = color ? color : colors.surface.black;

  return (
    <CustomSvg
      className={className}
      data-cy={testId}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M15.9688 3.96939C16.0384 3.89965 16.1212 3.84433 16.2122 3.80659C16.3033 3.76885 16.4008 3.74942 16.4994 3.74942C16.598 3.74942 16.6956 3.76885 16.7866 3.80659C16.8777 3.84433 16.9604 3.89965 17.03 3.96939L20.03 6.96938C20.135 7.07428 20.2066 7.20797 20.2356 7.35353C20.2645 7.49909 20.2497 7.64999 20.1929 7.7871C20.1361 7.92422 20.0398 8.0414 19.9164 8.1238C19.793 8.2062 19.6478 8.25013 19.4994 8.25001L17.2494 8.25001L17.2494 19.5C17.2494 19.6989 17.1704 19.8897 17.0297 20.0303C16.8891 20.171 16.6983 20.25 16.4994 20.25C16.3005 20.25 16.1097 20.171 15.9691 20.0303C15.8284 19.8897 15.7494 19.6989 15.7494 19.5L15.7494 8.25001L13.4994 8.25001C13.351 8.25013 13.2059 8.2062 13.0824 8.1238C12.959 8.0414 12.8628 7.92422 12.8059 7.7871C12.7491 7.64999 12.7343 7.49909 12.7633 7.35353C12.7922 7.20797 12.8638 7.07428 12.9688 6.96938L15.9688 3.96939ZM8.03003 20.0306L11.03 17.0306C11.135 16.9257 11.2066 16.7921 11.2356 16.6465C11.2645 16.5009 11.2497 16.35 11.1929 16.2129C11.1361 16.0758 11.0398 15.9586 10.9164 15.8762C10.7929 15.7938 10.6478 15.7499 10.4994 15.75L8.24941 15.75L8.24941 4.50001C8.24941 4.3011 8.17039 4.11033 8.02974 3.96968C7.88909 3.82903 7.69832 3.75001 7.49941 3.75001C7.3005 3.75001 7.10973 3.82903 6.96908 3.96968C6.82843 4.11033 6.74941 4.3011 6.74941 4.50001L6.74941 15.75L4.49941 15.75C4.35099 15.7499 4.20587 15.7938 4.08242 15.8762C3.95897 15.9586 3.86276 16.0758 3.80594 16.2129C3.74913 16.35 3.73427 16.5009 3.76326 16.6465C3.79225 16.7921 3.86377 16.9257 3.96878 17.0306L6.96878 20.0306C7.03844 20.1004 7.12115 20.1557 7.2122 20.1934C7.30325 20.2312 7.40085 20.2506 7.49941 20.2506C7.59797 20.2506 7.69556 20.2312 7.78661 20.1934C7.87766 20.1557 7.96038 20.1004 8.03003 20.0306Z"
        fill={iconColor}
      />
    </CustomSvg>
  );
};

export default SwapIconGe;
